import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AppError, ServerSide } from '@interticket/core';
import { ErrorLoggerService } from './error-logger.service';

/**
 * {@link} https://medium.com/angular-in-depth/expecting-the-unexpected-best-practices-for-error-handling-in-angular-21c3662ef9e4
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    protected injector: Injector
  ) { }

  handleError(error: AppError): void {
    const logger = this.injector.get(ErrorLoggerService);

    // Logging Error
    this.logSSR({ error });
    logger.logError(error);
  }

  @ServerSide()
  logSSR(error: any) {
    console.error(error);
  }

}
